(() => {
  'use strict';
  if (window.NaryssLamuCanada) return;
  const product = 10557110255905;
  const owned = new Set(['LAMU-DUO', 'LAMU-TRIO']);
  const root = window.Shopify?.routes?.root || '/';
  const market = window.NaryssLamuMarket || {};
  const storageKey = 'naryss-lamu-canada-code';
  let pending = null;
  let timer;
  let bypassCheckout = false;

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: {Accept: 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})},
      ...(body ? {body: JSON.stringify(body)} : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update the offer.');
    return result;
  }

  function codes(cart) {
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.map(entry => typeof entry === 'string' ? entry : entry.code).filter(Boolean);
    }
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      }
    }
    return [...new Set(applications.filter(app => app.type === 'discount_code').map(app => app.title))];
  }

  function readTracked() {
    try { return sessionStorage.getItem(storageKey) || ''; } catch (_) { return ''; }
  }

  function track(code) {
    try {
      if (code) sessionStorage.setItem(storageKey, code);
      else sessionStorage.removeItem(storageKey);
    } catch (_) {}
  }

  function desired(cart) {
    const lamu = (cart.items || []).filter(item => item.product_id === product);
    if (market.country !== 'CA' || cart.currency !== 'CAD' || !lamu.length ||
        lamu.some(item => item.original_price !== 4900 || item.selling_plan_allocation)) return '';
    const count = lamu.reduce((sum, item) => sum + item.quantity, 0);
    return count === 2 ? 'LAMU-DUO' : count === 3 ? 'LAMU-TRIO' : '';
  }

  async function synchronize() {
    let cart = await request('cart.js');
    const target = desired(cart);
    const existing = codes(cart);
    const other = existing.filter(code => !owned.has(code.toUpperCase()));
    const present = existing.filter(code => owned.has(code.toUpperCase())).map(code => code.toUpperCase());
    const tracked = readTracked();
    const mustChange = target ? present.length !== 1 || present[0] !== target : present.length > 0 || !!tracked;
    if (mustChange) {
      const next = [...other, ...(target ? [target] : [])];
      await request('cart/update.js', {discount: next.join(',')});
      cart = await request('cart.js');
      track(target);
    }
    if (target && !other.length && cart.items.every(item => item.product_id === product)) {
      const expected = target === 'LAMU-DUO' ? 7900 : 10800;
      if (cart.total_price !== expected) {
        throw new Error('The Lamu offer could not be confirmed. Please check your bag before checkout.');
      }
    }
    return cart;
  }

  function ensure() {
    if (!pending) pending = synchronize().finally(() => { pending = null; });
    return pending;
  }

  function showError(error) {
    let notice = document.getElementById('NaryssLamuCanadaError');
    const container = document.getElementById('main-cart-items');
    if (!container) return;
    if (!notice) {
      notice = document.createElement('p');
      notice.id = 'NaryssLamuCanadaError';
      notice.className = 'naryss-cart-offer__error';
      notice.setAttribute('role', 'alert');
      container.appendChild(notice);
    }
    notice.textContent = error.message;
  }

  async function refreshCart() {
    try {
      const before = await request('cart.js');
      const after = await ensure();
      if (before.total_price !== after.total_price || codes(before).join(',') !== codes(after).join(',')) {
        window.location.reload();
      }
    } catch (error) { showError(error); }
  }

  window.NaryssLamuCanada = {ensure};

  function setup() {
    if (market.currency !== 'CAD' && !readTracked()) return;
    const cart = document.getElementById('main-cart-items');
    if (!cart) return;
    void refreshCart();
    new MutationObserver(records => {
      const changed = records.some(record =>
        !record.target.closest?.('[data-naryss-cart-offer], #NaryssLamuCanadaError') &&
        ![...record.addedNodes].some(node => node.id === 'NaryssLamuCanadaError'));
      if (!changed || pending) return;
      clearTimeout(timer);
      timer = setTimeout(refreshCart, 250);
    }).observe(cart, {childList: true, subtree: true});
    document.addEventListener('submit', async event => {
      if (bypassCheckout || !event.submitter?.matches('[name="checkout"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = event.target;
      const button = event.submitter;
      button.disabled = true;
      try {
        await ensure();
        bypassCheckout = true;
        button.disabled = false;
        form.requestSubmit(button);
      } catch (error) { showError(error); button.disabled = false; }
      finally { bypassCheckout = false; }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once: true});
  else setup();
})();
